import { z } from 'zod';
import { RECORD_STATUSES } from '../enums';

export const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid id');

export const recordStatus = z.enum(RECORD_STATUSES);

/** Query string shared by every list endpoint. `sort` is a field name, prefix `-` for descending. */
export const listQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(10),
  sort: z.string().trim().max(60).optional(),
});
export type ListQuery = z.infer<typeof listQuerySchema>;

export interface Paged<T> {
  data: T[];
  page: number;
  pageSize: number;
  total: number;
}

export interface ApiErrorBody {
  error: {
    code: string;
    message: string;
    details?: Array<{ path: string; message: string }> | Record<string, unknown>;
  };
}

/** Query-string boolean: "true" / "false" / absent. */
export const queryBool = z
  .enum(['true', 'false'])
  .transform((v) => v === 'true')
  .optional();

/** Optional text filter: empty string is treated as absent. */
export const optionalText = (max = 100) =>
  z
    .string()
    .trim()
    .max(max)
    .optional()
    .transform((v) => (v ? v : undefined));

export const digits = (min: number, max: number, label: string) =>
  z
    .string()
    .trim()
    .regex(
      new RegExp(`^\\d{${min},${max}}$`),
      `${label} must be ${min === max ? min : `${min} to ${max}`} digits`,
    );

/** Escapes user text for use inside a MongoDB `$regex`. */
export const escapeRegex = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
